/**
 * 좌우로 넘기는 줄(.scroller) — Alpine 컴포넌트.
 *
 * 스크롤 위치를 보고 "이쪽에 아직 더 있다"를 감싸는 요소의 data-start / data-end 로 알린다.
 * 페이드는 CSS 가 그 값을 보고 켠다 — 끝에 닿은 쪽은 자동으로 꺼진다.
 *
 * <div class="scroller" x-data="scroller">
 *   <div class="scroller__track" x-ref="track">…</div>
 * </div>
 */

const scroller = () => ({
  atStart: true,
  atEnd: true,

  init() {
    const track = this.$refs.track;

    if (!track) {
      return;
    }

    this.sync();
    // 현재 항목이 화면 밖에 있으면(예: 모바일 헤더 메뉴) 보이는 자리로 미리 옮겨 둔다
    this.showCurrent();

    track.addEventListener('scroll', () => this.sync(), { passive: true });
    window.addEventListener('resize', () => this.sync());

    // 항목이 늘거나 줄면 끝 위치도 달라진다
    new ResizeObserver(() => this.sync()).observe(track);
  },

  /**
   * 현재 항목을 가운데로 보낸다. 줄 안에서만 가로로 움직이므로
   * 페이지 세로 스크롤은 건드리지 않는다 (scrollIntoView 를 쓰지 않는 이유).
   */
  showCurrent(smooth = false) {
    const track = this.$refs.track;
    const current = track?.querySelector(
      '[aria-current], .pill-nav__link--current, .spy-nav__link--current'
    );

    if (!track || !current || track.scrollWidth <= track.clientWidth) {
      return;
    }

    const target = current.offsetLeft - (track.clientWidth - current.offsetWidth) / 2;

    track.scrollTo({ left: Math.max(target, 0), behavior: smooth ? 'smooth' : 'auto' });
  },

  sync() {
    const track = this.$refs.track;

    if (!track) {
      return;
    }

    // 소수점 오차·스냅 보정으로 끝에 닿아도 몇 px 남는 경우가 있어 여유를 둔다
    const max = track.scrollWidth - track.clientWidth;
    const slack = 2;

    this.atStart = track.scrollLeft <= slack;
    this.atEnd = track.scrollLeft >= max - slack;

    this.$el.dataset.start = String(this.atStart);
    this.$el.dataset.end = String(this.atEnd);
  },
});

export default scroller;
